import { render } from "./ErrorPage.vue?vue&type=template&id=003959cd"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/common/ErrorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "003959cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('003959cd', __exports__)) {
    api.reload('003959cd', __exports__)
  }
  
  module.hot.accept("./ErrorPage.vue?vue&type=template&id=003959cd", () => {
    api.rerender('003959cd', render)
  })

}


export default __exports__